<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<mat-card *ngIf="appState.user | async as user" class="rally-point-user-status-container">
	<mat-card-content>
		<p>
			{{ appStrings.RALLY_POINT_ACCESS_ALREADY_LOGGED_TEXT1 }}
			<span class="user-information">{{ user.firstName || user.email }}</span
			>{{ appStrings.RALLY_POINT_ACCESS_ALREADY_LOGGED_TEXT2 }}
		</p>
		<p>{{ appStrings.RALLY_POINT_ACCESS_ALREADY_LOGGED_TEXT3 }}</p>
	</mat-card-content>
</mat-card>

<div class="other-pages-header">
	<h1>{{ appStrings.RALLY_POINT_TITLE }}</h1>
	<p>{{ appStrings.RALLY_POINT_BODY }}</p>
</div>

<div>
	<form class="access-code-form" [formGroup]="rallyForm" (ngSubmit)="next()">
		<mat-form-field>
			<mat-label>{{ appStrings.RALLY_POINT_ACCESS_CODE_LABEL }}</mat-label>
			<input matInput autocomplete="accessCode" formControlName="accessCode" />
			<mat-error>{{ appStrings.FIELD_IS_REQUIRED }}</mat-error>
		</mat-form-field>
		<button-footer
			[saveOrCloseButtonText]="appStrings.RALLY_POINT_ACCESS_CODE_NEXT_BTN"
			[disabled]="!rallyForm.valid"
		>
			<button leftButton type="button" mat-stroked-button color="primary" (click)="onCancel()">
				{{ appStrings.RALLY_POINT_ACCESS_CODE_CANCEL_BTN }}
			</button>
		</button-footer>
	</form>
</div>
